exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dropZoneAttachmentModal{min-height:90px!important;margin-bottom:5px!important}#dropZoneAttachmentModal .dz-default.dz-message{display:block!important;margin:1em 0!important}#dropZoneAttachmentModal .dz-preview{display:none!important}", ""]);

// exports
